<div class="wrap">
  <fa-icon [icon]="faPaperPlane"></fa-icon>
  <h1>Changement de mot de passe en cours</h1>
  <p>Votre demande a bien été prise en compte.</p>
  <p>Un mail vous a été envoyé à l'adresse mail <span>{{email}}</span> </p>
  <p class="redirection">Redirection en cours <span>.</span><span>.</span><span>.</span> </p>
</div>